function Shopping() {
  return (
    <svg
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9 0.75C11.1994 0.75 12.9539 2.4898 12.9541 4.59961V5.75H17.1816C17.2071 5.75 17.225 5.75943 17.2363 5.77051C17.2472 5.78115 17.25 5.79053 17.25 5.7998V19.2002C17.25 19.2095 17.2472 19.2189 17.2363 19.2295C17.225 19.2406 17.2071 19.25 17.1816 19.25H0.818359C0.792897 19.25 0.774996 19.2406 0.763672 19.2295C0.752842 19.2189 0.750038 19.2095 0.75 19.2002V5.7998C0.750038 5.79053 0.752842 5.78115 0.763672 5.77051C0.774996 5.75943 0.792897 5.75 0.818359 5.75H5.0459V4.59961C5.04612 2.4898 6.80064 0.75 9 0.75ZM9 1.0498C7.01922 1.0498 5.38693 2.62228 5.38672 4.59961V5.75H12.6133V4.59961C12.6131 2.62228 10.9808 1.0498 9 1.0498Z'
        stroke='#949494'
        stroke-width='1.5'
      />
    </svg>
  );
}

function ActiveShopping() {
  return (
    <svg
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.1818 5H13.7045V4.6C13.7045 2.06 11.5977 0 9 0C6.40227 0 4.29545 2.06 4.29545 4.6V5H0.818182C0.365625 5 0 5.3575 0 5.8V19.2C0 19.6425 0.365625 20 0.818182 20H17.1818C17.6344 20 18 19.6425 18 19.2V5.8C18 5.3575 17.6344 5 17.1818 5ZM11.8636 5H6.13636V4.6C6.13636 3.0525 7.41733 1.8 9 1.8C10.5827 1.8 11.8636 3.0525 11.8636 4.6V5Z'
        fill='#3A3A3A'
      />
    </svg>
  );
}

export { Shopping, ActiveShopping };
